import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

const GET_SECONDARY_IDENTIFICATION = 'v2/guest/secondary-identification';

export type SecondaryIdentificationServerResponse = {
  IdentityId: number;
  Image: string;
  Name: string;
  StateId: string;
};

export const secondaryIdentificationKeys = {
  all: ['secondary-identification'] as const,
  many: (guestId: number) => [...secondaryIdentificationKeys.all, 'many', guestId] as const,
};

type SecondaryIdentificationPayload = {
  guestId: number;
  options?: Pick<UseQueryOptions<SecondaryIdentificationServerResponse[]>, 'enabled'>;
};

export const useSecondaryIdentificationQuery = ({ guestId, options }: SecondaryIdentificationPayload) => {
  const baseAPIParams = useBaseAPIParams();

  return useQuery({
    queryKey: secondaryIdentificationKeys.many(guestId),
    queryFn: async () => {
      const response = await post<SecondaryIdentificationServerResponse[]>(GET_SECONDARY_IDENTIFICATION, {
        ...baseAPIParams,
        guest_id: guestId,
      });

      return response;
    },
    enabled: !!guestId && (options?.enabled ?? true),
  });
};
